<template>
  <modal 
    name="mfa-confirm-modal-two" 
    :pivotY="0.2"
    :height="'auto'"
    :width="'560px'"
    @opened="opened"
    @before-open="beforeOpen">

    <!-- we are loading the pages right now -->
    <div class="border-b p-4 flex justify-between items-center">
      <div class="text-base text-gray-800">
        Please type in your 6-digit verification code
      </div>

      <a href="#"
        @click.prevent="$modal.hide('mfa-confirm-modal-two')"
        class="text-grey hover:text-grey-darker">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/img/feather-sprite.svg#x"/>
        </svg>
      </a>
    </div>
    
    <div class="p-4">

      <div class="text-base">
        We just sent you a 6-digit verification code to your mobile. Please type the code below.
      </div>

      <div class="text-base mt-6">
        <input type="text" class="input-standard" v-model="code" ref="code" />
        <div v-if="codeError != null" class="mt-2 text-red-600 text-sm">
          {{ codeError }}
        </div>
      </div>

      <div class="mt-8">
        <SubmitButton :onClick="submit" :loading="loading" label="Verify" :isFullWidth="true" />
      </div>

      <div class="mt-4 text-center">
        <a href="#" @click.prevent="sendAgain" class="text-sm text-gray-600 hover:underline">Didn't get the code? Send again</a>
      </div>      

    </div>
  </modal>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import SubmitButton   from '@/shared/components/form/SubmitButton'

  export default {

    components : {
      SubmitButton
    },

    props : {
      sendMFAVerificationCode : {
        type    : Function,
        required: true
      }
    },

    data() {
      return {
        loading  : false,
        code     : null,
        codeError: null,
      }
    },

    methods : {

      sendAgain() {
        this.loading = true
        this.sendMFAVerificationCode( (data) => {
          this.loading = false

          EventBus.$emit('notification-event', {
            'type'   : 'success', 
            'message': 'MFA code sent again.'
          })
        })
      },

      beforeOpen(event) {
        this.loading   = false
        this.code      = null
        this.codeError = null
      },

      opened(event) {
        this.$refs.code.focus()
      },

      submit() {
        this.loading = true
        this.apiPost({
          code: this.code
        }, 'auth/verify-mfa-code', (data) => {
          this.loading = false

          if(data != null && data.error != null) {
            this.codeError = data.error
          }

          else {
            this.$modal.hide('mfa-confirm-modal-two')
            this.$modal.show('mfa-confirm-modal-three')
            EventBus.$emit('refresh-user')
            EventBus.$emit('notification-event', {
              'type'   : 'success', 
              'message': 'MFA code verified successfully.'
            })
          }
        })
      }
    }
  }
</script>